
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import Button from '../../components/base/Button';

export default function ImpulsoDigital() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    empresa: '',
    sector: '',
    mensaje: ''
  });

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch(
        'https://readdy.ai/api/form/d40a1iu340kps7g5iv4g',
        {
          method: 'POST',
          body: formDataToSend
        }
      );

      if (response.ok) {
        alert('¡Solicitud enviada correctamente! Te contactaremos pronto.');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          empresa: '',
          sector: '',
          mensaje: ''
        });
      } else {
        alert('Error al enviar la solicitud. Por favor, inténtalo de nuevo.');
      }
    } catch (error) {
      alert('Error al enviar la solicitud. Por favor, inténtalo de nuevo.');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative py-20 overflow-hidden">
          {/* Imagen de fondo */}
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://public.readdy.ai/ai/img_res/81d8939162b27f2e1605559cb5e040e0.jpg')`
            }}
          />

          {/* Overlay para mejorar legibilidad */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/70 to-purple-900/70" />

          <div className="container mx-auto px-6 relative z-10">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
                Tu salto digital empieza aquí
              </h1>
              <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-12 mb-12">
                <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                  Te regalamos tu primera web profesional.
                </h2>
                <p className="text-2xl text-blue-600 font-semibold mb-8">
                  Porque tu negocio merece estar en Internet.
                </p>
                <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
                  Si eres autónomo o tienes una pequeña empresa sin web, te
                  ayudamos a dar el primer paso hacia la digitalización —
                  gratis y sin compromiso.
                </p>
                <Button size="lg" className="text-xl px-12 py-4">
                  Solicita tu web gratuita ahora
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Por qué lo hacemos */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-4xl font-bold text-gray-900 mb-8">
                Queremos que todos los negocios puedan competir en el mercado
                digital.
              </h2>
              <div className="text-lg text-gray-600 leading-relaxed space-y-6">
                <p>En Data Metanoia, creemos que la digitalización no debe ser un lujo.</p>
                <p>
                  Por eso, hemos creado el{' '}
                  <strong className="text-blue-600">Programa Impulso Digital</strong>,
                  una iniciativa que ofrece una web profesional gratuita a
                  autónomos y pequeñas empresas que aún no tienen presencia
                  online.
                </p>
                <p className="text-xl font-semibold text-gray-900">
                  Sin letras pequeñas. Sin cuotas ocultas. Solo tu oportunidad para
                  empezar a crecer.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Qué incluye */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="max-w-6xl mx-auto">
              <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
                Tu escaparate online, listo en pocos días.
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div className="bg-white rounded-xl p-8 shadow-lg">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                    <svg
                      className="w-8 h-8 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Dominio personalizado
                  </h3>
                  <p className="text-gray-600">(.com o .es) incluido el primer año</p>
                </div>

                <div className="bg-white rounded-xl p-8 shadow-lg">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                    <svg
                      className="w-8 h-8 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Diseño responsive
                  </h3>
                  <p className="text-gray-600">Profesional y adaptado a móviles</p>
                </div>

                <div className="bg-white rounded-xl p-8 shadow-lg">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                    <svg
                      className="w-8 h-8 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    SEO local optimizado
                  </h3>
                  <p className="text-gray-600">Textos optimizados para aparecer en Google</p>
                </div>

                <div className="bg-white rounded-xl p-8 shadow-lg">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                    <svg
                      className="w-8 h-8 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Integración WhatsApp
                  </h3>
                  <p className="text-gray-600">Y Google Maps para que te encuentren</p>
                </div>

                <div className="bg-white rounded-xl p-8 shadow-lg">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                    <svg
                      className="w-8 h-8 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Formulario de contacto
                  </h3>
                  <p className="text-gray-600">Automatizado y funcional</p>
                </div>

                <div className="bg-white rounded-xl p-8 shadow-lg">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                    <svg
                      className="w-8 h-8 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Asesoramiento digital
                  </h3>
                  <p className="text-gray-600">Para tu presencia online</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Crecemos contigo */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-4xl font-bold text-gray-900 mb-8">
                Y después, crecemos contigo.
              </h2>
              <p className="text-xl text-gray-600 mb-12">
                Una vez tu negocio esté online, puedes potenciar tus resultados con
                nuestros servicios:
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                <div className="bg-blue-50 rounded-xl p-8">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <svg
                      className="w-8 h-8 text-blue-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M7 4V2a1 1 0 011-1h8a1 1 0 011 1v2m-9 0h10m-10 0a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Gestión de redes sociales
                  </h3>
                  <p className="text-gray-600">Y creación de contenido profesional</p>
                </div>

                <div className="bg-green-50 rounded-xl p-8">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <svg
                      className="w-8 h-8 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Posicionamiento SEO
                  </h3>
                  <p className="text-gray-600">Y campañas Google Ads efectivas</p>
                </div>

                <div className="bg-purple-50 rounded-xl p-8">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <svg
                      className="w-8 h-8 text-purple-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Automatizaciones
                  </h3>
                  <p className="text-gray-600">Marketing e inteligencia artificial</p>
                </div>

                <div className="bg-yellow-50 rounded-xl p-8">
                  <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <svg
                      className="w-8 h-8 text-yellow-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Google My Business
                  </h3>
                  <p className="text-gray-600">Reseñas y reputación digital</p>
                </div>
              </div>

              <p className="text-xl font-semibold text-blue-600">
                No te vendemos servicios. Te acompañamos en tu evolución digital.
              </p>
            </div>
          </div>
        </section>

        {/* Cómo funciona */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
                Así de fácil es empezar
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
                <div className="text-center">
                  <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <span className="text-2xl font-bold text-white">1</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Rellena el formulario
                  </h3>
                  <p className="text-gray-600">De solicitud con tus datos básicos</p>
                </div>

                <div className="text-center">
                  <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <span className="text-2xl font-bold text-white">2</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Te contactamos
                  </h3>
                  <p className="text-gray-600">Para conocer tu negocio y necesidades</p>
                </div>

                <div className="text-center">
                  <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <span className="text-2xl font-bold text-white">3</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Diseñamos tu web
                  </h3>
                  <p className="text-gray-600">En menos de 7 días hábiles</p>
                </div>

                <div className="text-center">
                  <div className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <span className="text-2xl font-bold text-white">4</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    ¡Listo!
                  </h3>
                  <p className="text-gray-600">Ya estás en Internet</p>
                </div>
              </div>

              <div className="text-center">
                <Button size="lg" className="text-xl px-12 py-4">
                  Solicita tu web ahora
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Quiénes somos */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-4xl font-bold text-gray-900 mb-8">
                Somos Data Metanoia — marketing + inteligencia artificial para
                empresas reales.
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed">
                Ayudamos a pymes, marcas personales y negocios locales a crecer con
                estrategias digitales reales, automatizaciones inteligentes y
                resultados medibles.
              </p>
              <p className="text-xl font-semibold text-blue-600 mt-6">
                Nuestro compromiso: humanizar la tecnología para que esté al
                servicio de las personas.
              </p>
            </div>
          </div>
        </section>

        {/* Formulario de solicitud */}
        <section className="py-20 bg-gradient-to-br from-blue-600 to-purple-600">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                  Empieza hoy. Tu negocio digital te está esperando.
                </h2>
                <p className="text-xl text-blue-100 mb-8">
                  No pierdas más clientes por no tener presencia online.
                  <br />
                  Da el primer paso gratis con Data Metanoia.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl">
                <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
                  Solicita tu web gratuita
                </h3>

                <form
                  onSubmit={handleSubmit}
                  data-readdy-form
                  id="solicitud-web-gratuita"
                  className="space-y-6"
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label
                        htmlFor="nombre"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Nombre completo *
                      </label>
                      <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                        placeholder="Tu nombre completo"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Email *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                        placeholder="tu@email.com"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label
                        htmlFor="telefono"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Teléfono *
                      </label>
                      <input
                        type="tel"
                        id="telefono"
                        name="telefono"
                        value={formData.telefono}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                        placeholder="+34 600 000 000"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="empresa"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Nombre de tu negocio *
                      </label>
                      <input
                        type="text"
                        id="empresa"
                        name="empresa"
                        value={formData.empresa}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                        placeholder="Nombre de tu empresa"
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="sector"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Sector de tu negocio *
                    </label>
                    <select
                      id="sector"
                      name="sector"
                      value={formData.sector}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    >
                      <option value="">Selecciona tu sector</option>
                      <option value="Peluquería/Estética">Peluquería/Estética</option>
                      <option value="Restauración">Restauración</option>
                      <option value="Fisioterapia/Salud">Fisioterapia/Salud</option>
                      <option value="Abogados/Consultoría">Abogados/Consultoría</option>
                      <option value="Electricista/Fontanero">Electricista/Fontanero</option>
                      <option value="Tienda local">Tienda local</option>
                      <option value="Servicios profesionales">
                        Servicios profesionales
                      </option>
                      <option value="Otro">Otro</option>
                    </select>
                  </div>

                  <div>
                    <label
                      htmlFor="mensaje"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Cuéntanos sobre tu negocio
                    </label>
                    <textarea
                      id="mensaje"
                      name="mensaje"
                      value={formData.mensaje}
                      onChange={handleInputChange}
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                      placeholder="Describe brevemente tu negocio, servicios y qué te gustaría destacar en tu web..."
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Máximo 500 caracteres
                    </p>
                  </div>

                  <div className="text-center pt-6">
                    <Button
                      type="submit"
                      size="lg"
                      className="w-full md:w-auto text-xl px-12 py-4"
                    >
                      Solicitar mi web gratuita
                    </Button>
                    <p className="text-sm text-gray-500 mt-4">
                      * Campos obligatorios. Te contactaremos en menos de 24
                      horas.
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
